import { DistanceText, StoreAddressText, StoreDetailsContainer } from './styles';

export const NearbyStoreDetails = ({
  address,
  distance,
}: {
  address: string;
  distance: string;
}) => {
  return (
    <StoreDetailsContainer accessible accessibilityRole="text">
      <StoreAddressText>{address}</StoreAddressText>
      <DistanceText>{distance}</DistanceText>
    </StoreDetailsContainer>
  );
};
